import Seo from "@/components/Seo";
import Hero from "@/components/home/Hero";
import FeaturesBento from "@/components/home/FeaturesBento";
import Screenshots from "@/components/home/Screenshots";
import HowItWorks from "@/components/home/HowItWorks";
import Testimonials from "@/components/home/Testimonials";
import Faq from "@/components/home/Faq";
import DownloadCTA from "@/components/home/DownloadCTA";

export default function Home() {
  return (
    <>
      <Seo path="/" />
      <Hero />
      <FeaturesBento />
      <Screenshots />
      <HowItWorks />
      <Testimonials />
      <Faq />
      <DownloadCTA />
    </>
  );
}
